export default __webpack_public_path__ + "static/media/smiley.336daf8f.svg";